import styled from 'styled-components'

export const Wrapper = styled.div<{ desktopColumn?: boolean }>`
    display: flex;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    margin-left: -15px;
    margin-right: -15px;

    &::-webkit-scrollbar {
        height: 0;
        width: 0;
    }

    @media ${(props) => props.theme.query.min.tablet} {
        overflow-x: initial;
        flex-wrap: inherit;
        ${(props) => props.desktopColumn && `flex-direction: column;`}
    }
`

export const Item = styled.div<{ desktopColumn?: boolean }>`
    flex: 1 0 100%;
    scroll-snap-align: start;
    padding: 15px;

    @media ${(props) => props.theme.query.min.tablet} {
        flex: 33%;
        ${(props) => props.desktopColumn && `flex: auto;`}
    }
`

export const Dots = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 40px;

    @media ${(props) => props.theme.query.min.tablet} {
        display: none;
    }
`

export const Dot = styled.div<{ active?: boolean }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 5px;
    background: ${(props) => props.theme.color.g200};

    ${(props) =>
        props.active &&
        `
      width: 12px;
      height: 12px;
      background: ${props.theme.color.p500};
    `}
`
